export const initialChatInterfaceWidthPx = 380;
export const minChatInterfaceWidthPx = 380;
export const maxChatInterfaceWidthPx = 900;
